import { httpsCallable } from 'firebase/functions';
import type { Timestamp } from 'firebase/firestore';

import { functions } from '@/src/lib/functions';

export type AccountDeletionStatus =
  | 'scheduled'
  | 'canceled'
  | 'purging'
  | 'completed'
  | 'completed_no_data_found'
  | 'failed';

export type AccountDeletionState = {
  confirmationCode: string;
  purgeAfter: Timestamp | Date | null;
  requestedAt: Timestamp | Date | null;
  source: 'account_settings' | 'facebook_callback' | 'age_gate';
  status: AccountDeletionStatus;
};

type RequestAccountDeletionResult = {
  confirmationCode: string;
  purgeAfter: string;
  status: AccountDeletionStatus;
};

type CancelAccountDeletionResult = {
  status: AccountDeletionStatus;
};

const requestAccountDeletionCallable = httpsCallable<
  { source?: 'account_settings' | 'age_gate' },
  RequestAccountDeletionResult
>(functions, 'requestAccountDeletion');

const cancelAccountDeletionCallable = httpsCallable<
  Record<string, never>,
  CancelAccountDeletionResult
>(functions, 'cancelAccountDeletion');

export async function requestAccountDeletion(
  source: 'account_settings' | 'age_gate' = 'account_settings',
) {
  const result = await requestAccountDeletionCallable({ source });
  return result.data;
}

export async function cancelAccountDeletion() {
  const result = await cancelAccountDeletionCallable({});
  return result.data;
}

export function isDeletionBlocking(
  deletion: AccountDeletionState | null | undefined,
) {
  return (
    deletion?.status === 'scheduled' ||
    deletion?.status === 'purging' ||
    deletion?.status === 'failed'
  );
}
